import { createFileRoute, redirect } from "@tanstack/react-router";

import { APP_ROUTERS } from "@/constants/app-routers";

export const Route = createFileRoute("/(member)/(protected)/my/")({
  beforeLoad: async () => {
    throw redirect({
      to: APP_ROUTERS.MY_PLACES,
      search: (prev) => ({
        ...prev,
        addOns: prev?.addOns || [],
      }),
    });
  },
});
